import { IStaticSettings } from "../models/app-settings";

export let staticSettings: IStaticSettings = {} as IStaticSettings;

/**
 * @description
 * Used to set app settings. This must be executed before any code relying on app settings.
 */
export function setStaticSettings(settings: IStaticSettings): void {
    staticSettings = settings;
}
